import * as yup from 'yup';
import { TryMyOllie } from '@web/components';
import {
  requiredImageFromCMSSchema,
  nullableImageFromCMSSchema,
  linkSchema,
} from '../schemas';
import { schema as testimonalSchema } from './testimonial';
import { schema as ctaGroupSchema } from './cta_group';

export const component = TryMyOllie;

const mealPlanSchema = yup
  .object({
    title: yup.string().required(),
    img: requiredImageFromCMSSchema,
    benefit: yup.string(),
    benefitVariant: yup.string(),
    benefitIcon: nullableImageFromCMSSchema,
    benefitIconAlignment: yup.string(),
    description: yup.string(),
  })
  .transform(value => ({
    title: value.title,
    img: value.img,
    benefit: value.benefit,
    benefitVariant: value.benefit_variant || undefined,
    benefitIcon: value.benefit_icon || undefined,
    benefitIconAlignment: value.benefit_icon_alignment || undefined,
    description: value.description,
  }));

export const schema = yup
  .object({
    headline: yup.string().required(),
    subheadline: yup.string(),
    typography: yup.string(),
    backgroundColor: yup.string(),
    mealPlanTypes: yup.array(mealPlanSchema),
    testimonials: yup.array(testimonalSchema),
    image: requiredImageFromCMSSchema,
    cta: yup.lazy(item => {
      switch (item?.component) {
        case 'cta_group':
          return ctaGroupSchema;
        default:
          return linkSchema;
      }
    }),
    reviewsCopy: yup.string(),
    starColor: yup.string(),
    id: yup.string(),
  })
  .transform(value => ({
    headline: value.headline,
    subheadline: value.subheadline,
    typography: value.typography || undefined,
    backgroundColor: value.backgroundColor || undefined,
    mealPlanTypes: value.mealPlanTypes,
    image: value.image,
    cta: value.cta?.[0],
    testimonials: value.testimonials,
    reviewsCopy: value.reviewsCopy,
    id: value.id || value.component,
    starColor: value.starColor || undefined,
  }));
